import { render, staticRenderFns } from "./ExpenseShow.vue?vue&type=template&id=16d3e5e6&scoped=true"
import script from "./ExpenseShow.vue?vue&type=script&lang=js"
export * from "./ExpenseShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3e5e6",
  null
  
)

export default component.exports